import React from 'react';
import { STEPS } from './constants';

const SignupProgress = ({ step, setStep }) => (
  <div className="flex items-center justify-center gap-1 mb-6" data-testid="signup-progress">
    {STEPS.map((s, i) => {
      const Icon = s.icon;
      const isActive = step === s.id;
      const isDone = step > s.id;
      return (
        <React.Fragment key={s.id}>
          <button
            type="button"
            onClick={() => {
              if (isDone) setStep(s.id);
            }}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-all
              ${
                isActive
                  ? 'bg-indigo-900 text-white'
                  : isDone
                  ? 'bg-indigo-100 text-indigo-700 cursor-pointer'
                  : 'bg-slate-100 text-slate-400'
              }`}
            data-testid={`step-${s.id}`}
          >
            <Icon size={14} weight={isActive ? 'fill' : 'regular'} />
            <span className="hidden sm:inline">{s.title}</span>
          </button>
          {i < STEPS.length - 1 && (
            <div className={`w-6 h-px ${isDone ? 'bg-indigo-300' : 'bg-slate-200'}`} />
          )}
        </React.Fragment>
      );
    })}
  </div>
);

export default SignupProgress;
